import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PublicRideViewControllerDelegate, PublicRideViewController } from "../../Screen/PublicRide/PublicRideViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PublicRideViewModel } from '../../Screen/PublicRide/PublicRideViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PublicRideCoordinator implements IndexCoordinatorDelegate, PublicRideViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppasseiopublico")
        return (<ProtectedRoute path="/:base/passeio-publico" exact={true} component={(props: any) => {
            return (<TableGenericViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Passeio Público"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PublicRideViewModel()
        return (<ProtectedRoute path="/:base/passeio-publico/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PublicRideViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppasseiopublico") {
            navigation.history.push(`passeio-publico/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppasseiopublico") {
            navigation.history.push(`passeio-publico/cad/${idSelection}`);
            return;
        }
    }

}